<template>
  <div class="yqn-autograph-box">
    <div class="autograph-box">
      <div class="inside">
       <div>
         <span class="btn-close" @click="$router.go(-1)">取消</span>
         <span class="btn-close" @click="closeFull">重写</span>
         <span class="btn-confirm" @click="confirmFull">提交</span>
       </div>

      </div>
      <div  class="canvasDiv" >
        <canvas class="xhy-canvas"/>
        <span  v-if="isPlaceholder">请在此区域内进行签字</span>
      </div>

    </div>
  </div>
</template>

<script>
import SignaturePad from 'signature_pad';

export default {
  name: "xhy-autograph",
  props: {
    config: {
      type: Object,
      default: {
        penColor: 'black', //笔刷颜色
        minWidth: 2, //最小宽度
      }
    }
  },
  data() {
    return {
      signaturePad: null,
      value: '',
      fullValue: '',
      isPlaceholder:true
    }
  },

  mounted() {
    this.init();
  },
  watch:{
    signaturePad:{
      deep:true,
      handler(newVal){
        this.isPlaceholder = newVal.isEmpty()
      }
    }
  },
  methods: {
    getSignTime(){
      // 创建一个新的Date对象，表示当前时间
      let currentDate = new Date();
      let year = currentDate.getFullYear();
      let month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // 月份从0开始，所以要加1，并补零
      let day = currentDate.getDate().toString().padStart(2, '0'); // 补零
      let hours = currentDate.getHours().toString().padStart(2, '0'); // 补零
      let minutes = currentDate.getMinutes().toString().padStart(2, '0'); // 补零
      let seconds = currentDate.getSeconds().toString().padStart(2, '0'); // 补零
      // let formattedDateTime = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
      return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes
    },
    init() {
      if (!this.signaturePad) {
        let canvas = document.querySelector('.xhy-canvas');
        this.signaturePad = new SignaturePad(canvas, this.config);
        this.signaturePad.onEnd = () => {
          this.$emit('receive', this.signaturePad.toDataURL()); //通知父组件改变。
        }
        canvas.height = document.body.clientHeight -54;
        canvas.width = document.body.clientWidth - 75;
        canvas.background = 'fff'
      }
    },
    closeFull() {
      this.signaturePad.clear();
      // this.$emit('receive', ''); //通知父组件改变。
    },
    confirmFull() {
      try {
        let _flag = this.signaturePad.isEmpty();
        if (!_flag) {
          this.fullValue = this.signaturePad.toDataURL();
          this.rotateBase64Img(this.fullValue, 270, res => {
            let _option = {
              width: document.body.clientWidth - 30,
              height: document.body.clientHeight / 3
            }
            let signObj = {
              signTime :this.getSignTime(),
              dsrSignet:res
            }
            this.$emit('receive', signObj);

          })
        }else{
          this.$CDialog({
            confirmBtnText: "确认",
            title: "提示",
            status: "2",
            message: '请在绘制区域内进行签字'
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    // base64图片旋转方法
    rotateBase64Img(src, edg, callback) {
      var canvas = document.createElement("canvas");
      var ctx = canvas.getContext("2d");
      var imgW; //图片宽度
      var imgH; //图片高度
      var size; //canvas初始大小
      if (edg % 90 != 0) {
        console.error("旋转角度必须是90的倍数!");
        throw '旋转角度必须是90的倍数!';
      }
      (edg < 0) && (edg = (edg % 360) + 360)
      const quadrant = (edg / 90) % 4; //旋转象限
      const cutCoor = {
        sx: 0,
        sy: 0,
        ex: 0,
        ey: 0
      }; //裁剪坐标
      var image = new Image();
      image.crossOrigin = "anonymous"
      image.src = src;
      image.onload = function () {
        imgW = image.width;
        imgH = image.height;
        size = imgW > imgH ? imgW : imgH;
        canvas.width = size * 2;
        canvas.height = size * 2;
        switch (quadrant) {
          case 0:
            cutCoor.sx = size;
            cutCoor.sy = size;
            cutCoor.ex = size + imgW;
            cutCoor.ey = size + imgH;
            break;
          case 1:
            cutCoor.sx = size - imgH;
            cutCoor.sy = size;
            cutCoor.ex = size;
            cutCoor.ey = size + imgW;
            break;
          case 2:
            cutCoor.sx = size - imgW;
            cutCoor.sy = size - imgH;
            cutCoor.ex = size;
            cutCoor.ey = size;
            break;
          case 3:
            cutCoor.sx = size;
            cutCoor.sy = size - imgW;
            cutCoor.ex = size + imgH;
            cutCoor.ey = size + imgW;
            break;
        }
        ctx.translate(size, size);
        ctx.rotate(edg * Math.PI / 180);
        ctx.drawImage(image, 0, 0);
        var imgData = ctx.getImageData(cutCoor.sx, cutCoor.sy, cutCoor.ex, cutCoor.ey);
        if (quadrant % 2 == 0) {
          canvas.width = imgW;
          canvas.height = imgH;
        } else {
          canvas.width = imgH;
          canvas.height = imgW;
        }
        ctx.putImageData(imgData, 0, 0);
        callback(canvas.toDataURL())
      };
    }
  }

}
</script>

<style lang="scss" scoped>
.yqn-autograph-box {
  height: calc(100vh - 46px);

  .autograph-box {
    display: flex;
    height: 100%;
    .inside {
      width: 75px;
      height: 100%;
      background: #e8f3ff;
      flex-direction: column;
      display: flex;
      justify-content: center;
      position: relative;
      div{
        transform: rotate(90deg);
        display: flex;
        width: 300px;
        position: absolute;
        left: -112px;
        top: 45%;
        span{
          display: block;
          font-size: 18px;
          letter-spacing: -1.67px;
          text-align: center;
          font-weight: 400;
          width: 120px;
          height: 40px;
          border: 1px solid;
          line-height: 40px;
          border-radius: 22px;
        }
        span:nth-of-type(1){
          border-color: #cccccc;
          color: #464A4C;
        }
        span:nth-of-type(2){
          margin: 0 10px;
          border-color: #58abff;
          color: #58abff;
        }
        span:nth-of-type(3){
          background-image: linear-gradient(-69deg, #54ADFB 0%, #297BF4 100%);
          color: #fff;
        }
      }


    }

    .xhy-canvas {
        background: #fff;
    }
  }
}
.canvasDiv{
  position: relative;
  flex: 1 1 auto;
  span{
    font-size: 0.64rem;
    color: #999999;
    letter-spacing: 0;
    line-height: 0.58667rem;
    font-weight: 400;
    position: absolute;
    top: 50%;
    left: 24px;
    z-index: 1;
    transform: rotate(90deg);
  }
}
</style>

